/** @typedef {import('./types.js').NoteContentBlock} NoteContentBlock */

/** @param {NoteContentBlock[]} [blocks] */
export function blocksToPlainText(blocks) {
  if (!blocks?.length) return ''

  const parts = []
  for (const block of blocks) {
    switch (block.type) {
      case 'heading':
      case 'paragraph':
      case 'quote':
        parts.push(block.text)
        break
      case 'bullets':
      case 'numbered':
        parts.push(...block.items)
        break
      case 'checklist':
        parts.push(...block.items.map((item) => item.text))
        break
      default:
        break
    }
  }
  return parts.join(' ')
}
